import { selectPlaceData } from 'containers/MapDetails/placeSlice'
import usePlaceFilters from './hooks/usePlaceFilters'
import useTranslation from 'hooks/useTranslation'
import { useReduxSelector } from 'store'
import React from 'react'

interface HeaderProps {
  isMap: boolean
  showMap: React.Dispatch<React.SetStateAction<boolean>>
}

export interface Size {
  warehouseTypeId: string
  name: string
  sizeShortName: string
  size: number
  capacity: number
  internalHeight: string
  internalLength: string
  internalWidth: string
  doorHeight: string
  doorWidth: string
  monthlyGrossPrice: string
  sqmPrice: string
  renders: {
    default: string
    transparent: string
  }
  fits: any[]
}

const Header: React.FC<HeaderProps> = ({ isMap, showMap }) => {
  const [filters, setFilters] = usePlaceFilters()
  const place = useReduxSelector(selectPlaceData)

  const variants = (filters?.attributes?.warehouseTypeId && place?.warehouses && place.warehouses[filters.attributes.warehouseTypeId])
    ? Object.entries(place.warehouses[filters.attributes.warehouseTypeId])
    : undefined

  const { t } = useTranslation('placeMap')

  return (
    <div className='placeMap__header'>
      <div className='placeMap__header__list'>
        <div className='placeMap__header__options'>
          <p>{t('size')}:</p>
          {place?.sizes.map((size: Size) => {
            const isSelected = filters?.attributes?.warehouseTypeId === size.warehouseTypeId
            return <button
              key={size.warehouseTypeId}
              className={`button placeMap__header__option${isSelected ? ' --selected' : ''}`}
              onClick={() => {
                if (isSelected) {
                  const { hash, warehouseTypeId, ...attributes } = filters?.attributes || {}
                  setFilters({ ...filters, attributes })
                } else {
                  const { hash, ...attributes } = filters?.attributes || {}
                  setFilters({ ...filters, attributes: { ...attributes, warehouseTypeId: size.warehouseTypeId } })
                }
              }}>
              {size.sizeShortName}
            </button>
          })}
        </div>

        {variants && variants.length > 1 && <div className='placeMap__header__options'>
          <p>{t('variant')}:</p>
          {variants.map(([hash, data]) => {
            const isSelected = filters?.attributes?.hash === hash
            return <button
              key={hash}
              className={`button placeMap__header__option${isSelected ? ' --selected' : ''}`}
              onClick={() => {
                if (isSelected) {
                  const { hash, ...attributes } = filters?.attributes || {}
                  setFilters({ ...filters, attributes })
                } else {
                  setFilters({ ...filters, attributes: { ...filters?.attributes, hash } })
                }
              }}>
              {(data as basic.Form)?.name}
            </button>
          })}
        </div>}
      </div>

      <div className='placeMap__header__switch'>
        <div
          className={`placeMap__header__switch__item${isMap ? ' --selected' : ''}`}
          style={place?.displayOptions?.showMap ? undefined : { opacity: 0.5 }}
          onClick={() => {
            if (place?.displayOptions?.showMap) {
              showMap(true)
            }
          }}>
          {t('map')}
        </div>
        <div
          className={`placeMap__header__switch__item${isMap ? '' : ' --selected'}`}
          style={place?.displayOptions?.showList || place?.displayOptions?.listAllWarehouses ? undefined : { opacity: 0.5 }}
          onClick={() => {
            if (place?.displayOptions?.showList || place?.displayOptions?.listAllWarehouses) {
              showMap(false)
            }
          }}>
          {t('list')}
        </div>
      </div>
    </div>
  )
}

export default Header